// extracted by mini-css-extract-plugin
export default {"autoresize-textarea":"autoresize-textarea_autoresize-textarea__05U2A"};